import { Injectable, Provider } from '@angular/core';
// tslint:disable-next-line:max-line-length
import { StateService, OnInvalidCallback, Transition, StateObject, StateOrName, RawParams, TransitionOptions, TransitionPromise, HrefOptions, TargetState } from '@uirouter/angularjs';

@Injectable()
export class UiRouterState extends StateService {
  constructor() {
    super(null);
  }

  dispose(): void {
    throw new Error('Method not implemented.');
  }

  onInvalid(callback: OnInvalidCallback): Function {
    throw new Error('Method not implemented.');
  }

  reload(reloadState?: StateOrName): Promise<StateObject> {
    throw new Error('Method not implemented.');
  }
  go(to: StateOrName, params?: RawParams, options?: TransitionOptions): TransitionPromise {
    throw new Error('Method not implemented.');
  }
  target(identifier: StateOrName, params?: RawParams, options?: TransitionOptions): TargetState {
    throw new Error('Method not implemented.');
  }
  transitionTo(to: StateOrName, toParams?: RawParams, options?: TransitionOptions): TransitionPromise {
    throw new Error('Method not implemented.');
  }
  is(stateOrName: StateOrName, params?: RawParams, options?: any): boolean {
    throw new Error('Method not implemented.');
  }
  includes(stateOrName: StateOrName, params?: RawParams, options?: TransitionOptions): boolean {
    throw new Error('Method not implemented.');
  }
  href(stateOrName: StateOrName, params: RawParams, options?: HrefOptions): string {
    throw new Error('Method not implemented.');
  }
  defaultErrorHandler(handler?: (error: any) => void): (error: any) => void {
    throw new Error('Method not implemented.');
  }

  get(stateOrName?: any, base?: any): any {
    throw new Error('Method not implemented.');
  }

  lazyLoad(stateOrName: StateOrName, transition?: Transition): Promise<any> {
    throw new Error('Method not implemented.');
  }
}

export function UiRouterStateFactory(i: any) {
  return i.get('$state');
}

export const UiRouterStateProvider: Provider = {
  provide: UiRouterState,
  useFactory: UiRouterStateFactory,
  deps: ['$injector'],
};
